var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInTransitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.6875,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#A4D7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.025 21.2125L22.525 25.7125C22.375 25.8625 22.225 25.9375 22 25.9375C21.775 25.9375 21.625 25.8625 21.475 25.7125C21.175 25.4125 21.175 24.9625 21.475 24.6625L24.7 21.4375H14.5C14.05 21.4375 13.75 21.1375 13.75 20.6875C13.75 20.2375 14.05 19.9375 14.5 19.9375H24.7L21.475 16.7125C21.175 16.4125 21.175 15.9625 21.475 15.6625C21.775 15.3625 22.225 15.3625 22.525 15.6625L27.025 20.1625C27.1 20.2375 27.175 20.3125 27.175 20.3875C27.25 20.5375 27.25 20.7625 27.175 20.9875C27.175 21.0625 27.1 21.1375 27.025 21.2125Z",
    fill: "#3876BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24681_29984",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 15,
    width: 15,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.025 21.2125L22.525 25.7125C22.375 25.8625 22.225 25.9375 22 25.9375C21.775 25.9375 21.625 25.8625 21.475 25.7125C21.175 25.4125 21.175 24.9625 21.475 24.6625L24.7 21.4375H14.5C14.05 21.4375 13.75 21.1375 13.75 20.6875C13.75 20.2375 14.05 19.9375 14.5 19.9375H24.7L21.475 16.7125C21.175 16.4125 21.175 15.9625 21.475 15.6625C21.775 15.3625 22.225 15.3625 22.525 15.6625L27.025 20.1625C27.1 20.2375 27.175 20.3125 27.175 20.3875C27.25 20.5375 27.25 20.7625 27.175 20.9875C27.175 21.0625 27.1 21.1375 27.025 21.2125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24681_29984)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11.6875H29.5V29.6875H11.5V11.6875Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransitIcon);
export default __webpack_public_path__ + "static/media/InTransitIcon.b005b0f16e73dedb352501d7756f2c0a.svg";
export { ForwardRef as ReactComponent };